import { render, staticRenderFns } from "./popOrderRecord.vue?vue&type=template&id=2952799c"
import script from "./popOrderRecord.vue?vue&type=script&lang=js"
export * from "./popOrderRecord.vue?vue&type=script&lang=js"
import style0 from "./popOrderRecord.vue?vue&type=style&index=0&id=2952799c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2952799c')) {
      api.createRecord('2952799c', component.options)
    } else {
      api.reload('2952799c', component.options)
    }
    module.hot.accept("./popOrderRecord.vue?vue&type=template&id=2952799c", function () {
      api.rerender('2952799c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popOrderRecord/popOrderRecord.vue"
export default component.exports